import React from "react";
import { observer } from "mobx-react";
import {
  Card,
  CardPanel,
  IconHighlight,
  Button,
  Skeleton,
  WidgetEmptyErrorPlaceholder,
} from "@ann/web-components";
import { useAppointmentsSnapshot } from "../../../../hooks/useAppointmentsSnapshot";
import { AppointmentsContent } from "./components";
import ScrollableCardContent from "../ScrollableCardContent";

const Appointments = observer(() => {
  const { loading, error, isEmpty, appointments, meta, refetch } = useAppointmentsSnapshot();

  if (loading) {
    return <Skeleton height="429px" width="100%" />;
  }



  if (error) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              buttonText="Retry"
              icon="error"
              message="We couldn't load your Appointments. Please try again."
              onClick={refetch}
              showButton
              title="Something went wrong"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  if (isEmpty || !appointments.length) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              icon="calendarToday"
              message="We'll list confirmed appointments here."
              showButton={false}
              title="No appointments scheduled"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  const totalItems = appointments.length < 5 ? appointments.length : 5;

  return (
    <Card size="large">
      <CardPanel isExpandable={false}>
        <CardPanel.Header title="Appointments" subtitle={`(${totalItems})`}>
          <CardPanel.Header.LeftSlot>
            <IconHighlight
              icon="calendarToday"
              bgColor="primary"
              iconColor="primary"
              size="medium"
            />
          </CardPanel.Header.LeftSlot>
        </CardPanel.Header>
        <CardPanel.Content>
          <ScrollableCardContent>
            <AppointmentsContent appointments={appointments} />
          </ScrollableCardContent>
        </CardPanel.Content>
        <CardPanel.Actions>
          <Button size="medium" type="secondary" label="View all" />
        </CardPanel.Actions>
      </CardPanel>
    </Card>
  );
});

export default Appointments;
